import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M20.982 11.436a9 9 0 1 0 -9.966 9.51","key":"svg-0"}],["path",{"d":"M17.8 20.817l-2.172 1.138a.392 .392 0 0 1 -.568 -.41l.415 -2.411l-1.757 -1.707a.389 .389 0 0 1 .217 -.665l2.428 -.352l1.086 -2.193a.392 .392 0 0 1 .702 0l1.086 2.193l2.428 .352a.39 .39 0 0 1 .217 .665l-1.757 1.707l.414 2.41a.39 .39 0 0 1 -.567 .411l-2.172 -1.138z","key":"svg-1"}],["path",{"d":"M12 7v5l1 1","key":"svg-2"}]]

const IconClockStar = createReactComponent('outline', 'clock-star', 'ClockStar', __iconNode);

export default IconClockStar;